var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_c('input',{staticClass:"form-control",attrs:{"type":"text","name":_vm.name,"data-input":""},domProps:{"value":_vm.value}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }